export default "__VITE_ASSET__Cf5$s43d__"